export default __webpack_public_path__ + "static/media/ncmc.7137fbf9.svg";